import { render, staticRenderFns } from "./job_applications.vue?vue&type=template&id=61ba2ffa&scoped=true&"
import script from "./job_applications.vue?vue&type=script&lang=js&"
export * from "./job_applications.vue?vue&type=script&lang=js&"
import style0 from "./job_applications.vue?vue&type=style&index=0&id=61ba2ffa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba2ffa",
  null
  
)

export default component.exports